<script>
    import { text } from "svelte/internal";
    import { langTextStore } from "../store/langtexts.js";
    import { inputVariableStore } from "../store/inputVariables.js";
    import { factoryStore } from "../store/factories.js";
    import { createEventDispatcher, tick } from "svelte";
    import InputVar from "../SharedComponents/InputVar.svelte";
    import InputPercent from "../SharedComponents/InputPercent.svelte";
    import TitleWithHelp from "../SharedComponents/TitleWithHelp.svelte";
    import * as util from "../js/util.js";

    var timeout;
    const dispatch = createEventDispatcher();
    function bubbleChange(e) {
        try {
            clearTimeout(timeout);
            timeout = window.setTimeout(() => {
                dispatch("change", null);
            }, 100);
        } catch (s) {
            alert("error");
        }
    }

    function setVarAndBubble(varNameKey) {
        var settingsToSave = $factoryStore.currentCalculator;

        var theRealVar = settingsToSave.variables.find(
            (v) => v.varNameKey == varNameKey
        );
        if (theRealVar != null) {
            theRealVar.value = $inputVariableStore[varNameKey];
        } else {
            settingsToSave[varNameKey] = {
                varNameKey: varNameKey,
                dataType: "percent",
                displayType: "percent",
                formula: 0,
                readOnly: false,
                value: $inputVariableStore[varNameKey],
            };
        }
        bubbleChange();
    }
    const levels = [
        "lessthan1",
        "between1and2",
        "between2and3",
        "between3and4",
        "morethan4",
    ];
    const grades = util.getWageGradesForCountry($factoryStore.currentCalculator);

    function roundToTwo(num) {
        return +(Math.round(num + "e+6") + "e-6");
    }
    var totals = [0, 0, 0, 0, 0, 0, 0];
    $: recalcTotals($inputVariableStore);
    function recalcTotals(inputStore) {
        for (var grade in grades) {
            var tot = 0;
            for (var level in levels) {
                tot += inputStore[grades[grade] + levels[level]];
            }
            totals[grade] = roundToTwo(tot * 100);
        }
    }
</script>

<div class="container align-vertical-middle pane-plain wage-distribution">
    <div class="row">
        <div class="col-6  text-primary">
            <h2 class="m-0">
                <TitleWithHelp
                    variable={{
                        nameKey: "general-wage-distribution",
                    }}
                    baseKey=""
                />
            </h2>
        </div>
        <div class="col-6 text-primary text-right">
            {$langTextStore.getText(
                "general-wage-distribution-totals-must-add"
            )}
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <hr />
            <table class="table">
                <thead>
                    <tr>
                        <th class="first-col" />
                        {#each grades as grade, i}
                            <th
                                >{$langTextStore.getText(
                                    "general-wage-distribution-grade-" + grade
                                )}</th
                            >
                        {/each}
                    </tr>
                </thead>
                <tbody>
                    {#each levels as year, i}
                        <tr>
                            <td>
                                <TitleWithHelp
                                    variable={{
                                        nameKey:
                                            "general-wage-distribution-year-" +
                                            year,
                                    }}
                                    baseKey=""
                                />
                            </td>

                            {#each grades as grade, i}
                                <td>
                                    {#if $factoryStore.currentCalculator.variables && $factoryStore.currentCalculator.variables.find((v) => v.varNameKey == grade + year) != null}
                                        <InputPercent
                                            error={totals[i] != 100}
                                            on:keyup={() => {
                                                setVarAndBubble(grade + year);
                                            }}
                                            on:change={() => {
                                                setVarAndBubble(grade + year);
                                            }}
                                            bind:value={$inputVariableStore[
                                                grade + year
                                            ]}
                                        />
                                    {:else}
                                        missing variable {grade + year}
                                    {/if}
                                    <!-- <input type="text" class="alert" /> -->
                                </td>
                            {/each}
                        </tr>
                    {/each}
                    <tr>
                        <td class="font-weight-bold">Totals</td>
                        {#each grades as grade, i}
                            <td class="font-weight-bold totals">
                                {#if totals[i] != 100}
                                    <span class="alert"> {totals[i]}%</span>
                                {:else}
                                    {totals[i]} %
                                {/if}
                            </td>
                        {/each}
                    </tr>
                </tbody>
            </table>
            <hr />
        </div>
        <div class="col-12 text-right">
            <button
                type="button"
                on:click={() => dispatch("close", {})}
                class="btn btn-secondary width-unset ms-2 mt-3 mb-0"
            >
                {$langTextStore.getText("general-label-close")}
            </button>
        </div>
    </div>
</div>
<svelte:head>
    <style>
        body {
            background: #E9EDF0;
        }
        .wage-distribution hr {
            margin:1rem 0;

        }
        .alert {
            border
        }
        .wage-distribution input {
            margin-bottom:0;
        }
        .wage-distribution th {
            font-weight: normal;
        }
        .wage-distribution .totals {
            padding: .6rem;
        }
        .wage-distribution .first-col {
            min-width:160px;
        }
    </style>
</svelte:head>
